import "./lazyload-image.js";
import "lightbox2/dist/css/lightbox.min.css";


document.addEventListener("DOMContentLoaded", function () {
  // Trì hoãn việc tải các module không khẩn cấp

  function lazyLoadScriptOnScroll(selector, callback) {
    const loadedScripts = new Set(); // Lưu trữ các selector đã load script
  
    function checkElementsInView() {
      if (loadedScripts.has(selector)) return; // Nếu đã load, không làm gì nữa
  
      let elements = document.querySelectorAll(selector);
      if (!elements.length) return;
  
      for (const element of elements) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          console.log(`✅ Element ${selector} is in view.`);
          loadedScripts.add(selector); // Đánh dấu là đã load
          window.removeEventListener("scroll", checkElementsInView);
          if (callback) callback(); // Gọi callback khi phần tử xuất hiện
          break;
        }
      }
    }
  
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector) && !loadedScripts.has(selector)) {
        checkElementsInView();
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    if (document.readyState === "complete") {
      checkElementsInView();
    } else {
      window.addEventListener("load", checkElementsInView);
    }
  
    window.addEventListener("scroll", checkElementsInView);
  }
  
  // Sử dụng function:
  lazyLoadScriptOnScroll("#typed", () => import("./typed.js"));
  lazyLoadScriptOnScroll("video.lazy", () => import("./lazyload-video.js"));

  lazyLoadScriptOnScroll(".swiper-container", () => import("./swiper-new.js"));
  lazyLoadScriptOnScroll('[data-micromodal-open],[using-modal]', () => import("./modal.js"));

  lazyLoadScriptOnScroll("[data-lightbox], .art-gallery-x", () => import("./lightbox.js"));
  lazyLoadScriptOnScroll("[data-tippy-content]", () => import("./tooltip.js"));
  lazyLoadScriptOnScroll("#table-pricing", () => import("./pricing-page-nov-2024.js"));
  lazyLoadScriptOnScroll("#serviceSearch", () => import("./search-scope-of-service.js"));
  lazyLoadScriptOnScroll("#timer-display", () => import("./count-down.js"));
  lazyLoadScriptOnScroll("#companies-choose-4000", () => import("./home-hoverplay-video.js"));
  lazyLoadScriptOnScroll(".scroll-infinite", () => import("./scroll-double-list.js"));
  lazyLoadScriptOnScroll( "img[data-srcset], img[data-src]", () => import("./placeholder-lazyload-image.js"));
  lazyLoadScriptOnScroll( "#wpadminbar", () => import("./wp-admin-set-margin.js"));
  lazyLoadScriptOnScroll( "#header-navbar", () => import("./event-addclass-header.js"));
  lazyLoadScriptOnScroll( ".handy-collapsible-container", () => import("./collapse.js"));
  lazyLoadScriptOnScroll( "#show-code", () => import("./copy-clipboard.js"));
  lazyLoadScriptOnScroll( "#form_email input[type='email']", () => import("./service-form.js"));
  // 👉 Lazy load gsap.js
  lazyLoadScriptOnScroll('.scroll-text, .scrambler-wrapper, .gsap', async () => {
    const { default: runGsapAnimations } = await import('./gsap.js');
    runGsapAnimations();
  });


  function runWhenIdle(callback) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(callback);
    } else {
      // Fallback cho các trình duyệt không hỗ trợ requestIdleCallback
      setTimeout(callback, 2000);
    }
  }
  runWhenIdle(() => {
    // Các import khác giữ nguyên
    import("./smooth-scroll").then(({ scroll }) => {});

    const YoutubePopup = document.querySelectorAll("a.bla-1");
    if (YoutubePopup) {
      import("./YouTubePopUp.js");
    }
    // Play video demo
    const playVideoDemo = document.getElementById("play-video-demo");
    if (playVideoDemo) {
      playVideoDemo.addEventListener("click", function (event) {
        event.preventDefault();
        const player = new Vimeo.Player(document.getElementById("video-demo"));
        player.play();

        document.getElementById("video-demo").classList.remove("hidden");
        document.getElementById("image-video").classList.add("hidden");

        setTimeout(() => {
          document.getElementById("show-code").classList.add("active");
        }, 3000);
      });
    }

    // Popover live demo with event delegation
    const popover = document.querySelector(".popover");
    const wrapper = document.querySelector(".wrapper-popover");
    if (popover && wrapper) {
      document.body.addEventListener("click", function (event) {
        if (event.target.closest(".trigger-popover")) {
          console.log("trigger-popover");
          popover.classList.toggle("show-popover");
          wrapper.classList.toggle("active");
        } else if (
          event.target.matches(".close-button-popover") ||
          event.target === popover
        ) {
          popover.classList.remove("show-popover");
          wrapper.classList.remove("active");
        }
      });
    }
  });

  window.toggleMenu = function () {
    const menu = document.querySelector(".menu-mobile");
    const burger = document.getElementById("burger-mobile");
    const body = document.body;

    if (burger) burger.classList.toggle("open");
    if (menu) menu.classList.toggle("active");
    body.style.overflow = body.style.overflow === "hidden" ? "auto" : "hidden";
  };
  // remove error recapcha
  let observer = new MutationObserver(function (mutationsList, observer) {
    let targetDiv = document.querySelector(
        ".cp-recaptcha"
    );
    if (targetDiv) {
        targetDiv.remove();
        observer.disconnect(); // Dừng quan sát sau khi phần tử bị xóa
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });


  

  function clickChat() {
    Intercom("show");
  }
   function isValidEmail(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
   function onChangeInputCTA(input_id, input_elt) {
    if (isValidEmail(input_elt.value)) {
      document.getElementById(input_id).value = input_elt.value;
    } else {
      alert("The email is not valid");
    }
  }
  function onClickButtonCTA(input_id, button_elt, list_id) {
    console.log("onClickButtonCTA");
    var input = document.getElementById(input_id);
    var input_value = input.value;
  
    if (input_value && input_value !== "" && isValidEmail(input_value)) {
      var ItemJSON = `{"list_id":${list_id},"email":"${input_value}","name":"${input_value}"}`;
      console.log(ItemJSON);
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var res_send_finish = JSON.parse(this.responseText);
          console.log(res_send_finish);
          if (res_send_finish.success == true) {
            button_elt.textContent = "Sent";
            button_elt.disabled = "disabled";
            alert("Your email has been submitted");
            if (list_id == 112)
              window.location.replace("https://happy-new-year.penji.co");
          }
        }
      };
      xhttp.open("POST", "https://api.penji.co/api-user/add-brevo-by-id", true);
      xhttp.setRequestHeader("Content-type", "application/json");
      xhttp.send(ItemJSON);
    } else {
      alert("The email is not valid");
    }
  }
   function onClickButtonCTAV2(
    input_name_id,
    input_email_id,
    button_elt,
    list_id
  ) {
    document.getElementById("notify").style.display = "hidden";
    document.getElementById("notify").style.color = "#334155";
    document.getElementById("notify").innerHTML = "";
    var input_name_id = document.getElementById(input_name_id);
    var name = input_name_id.value;
    var input_email_id = document.getElementById(input_email_id);
    var email = input_email_id.value;
    console.log("Input Value:", name, email);
    if (name !== "" && email !== "") {
      var ItemJSON = `{"list_id":${list_id},"email":"${email}","name":"${name}"}`;
      console.log(ItemJSON);
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var res_send_finish = JSON.parse(this.responseText);
          console.log(res_send_finish);
          if (res_send_finish.success == true) {
            button_elt.textContent = "Sent";
            document.getElementById("notify").style.display = "block";
            document.getElementById("notify").innerHTML =
              "Thank you for subscribing to our newsletter. You'll be receiving your free ebook in your inbox shortly.";
          }
        }
      };
      xhttp.open("POST", "https://api.penji.co/api-user/add-brevo-by-id", true);
      xhttp.setRequestHeader("Content-type", "application/json");
      xhttp.send(ItemJSON);
    } else {
      document.getElementById("notify").style.display = "block";
      document.getElementById("notify").style.color = "#dc3232";
      document.getElementById("notify").innerHTML =
        "One or more fields have an error. Please check and try again.";
    }
  }
  window.onClickButtonCTA = onClickButtonCTA;
  window.onClickButtonCTAV2 = onClickButtonCTAV2;
  window.onChangeInputCTA = onChangeInputCTA;
  window.clickChat = clickChat;

  document.querySelectorAll('.cp-overlay-close').forEach(button => {
    button.addEventListener('click', () => {
      const overlay = button.closest('.cp-overlay');
      if (overlay) {
        overlay.classList.remove('cp-open');
      }
    });
  });



});
